import { Url } from "./Url.service";
import { HandleResponse, AuthHeader } from "../_helpers";


export const ConfiguracionesParametrizables = {
  urlRedireccionWhatsappKipit: () => `${Url}Configuraciones_parametrizables/redirigir`,

  obtenerNumeroWhatsappKipit: async () => {
    const response = await fetch(`${Url}Configuraciones_parametrizables/numero`);
    if (!response.ok) throw new Error("No se pudo obtener el número de WhatsApp");
    const data = await response.json();
    return data.numero;
  },

  storeNumero,
  updateNumero,
  obtenerTodosLosNumeros,
};

function storeNumero(data) {
    return fetch(
        `${Url}Configuraciones_parametrizables/crear-whatsapp-numeros`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...AuthHeader()
            },
            body: JSON.stringify(data)
        }
    ).then(HandleResponse);
}

function updateNumero(data) {
  const id = data?.id;

  if (!id) {
    throw new Error("Se requiere el id del numero para actualizar");
  }

  const payload = { ...data };  
  delete payload.id;

    return fetch(
    `${Url}Configuraciones_parametrizables/actualizar-whatsapp-numeros/${id}`,
        {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                ...AuthHeader()
            },
      body: JSON.stringify(payload)
        }
    ).then(HandleResponse);
}

function obtenerTodosLosNumeros(filtros = {}) {
    const queryParams = new URLSearchParams(filtros).toString();

    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}Configuraciones_parametrizables/obtener_numeros?${queryParams}`, requestOptions)
        .then(HandleResponse);
}